import { render } from "./OnboardingProcess.vue?vue&type=template&id=1a2ca32b&scoped=true"
import script from "./OnboardingProcess.vue?vue&type=script&lang=js"
export * from "./OnboardingProcess.vue?vue&type=script&lang=js"

import "./OnboardingProcess.vue?vue&type=style&index=0&id=1a2ca32b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2ca32b"]])

export default __exports__